import { render, staticRenderFns } from "./OrderPackageItems.vue?vue&type=template&id=e55ec3fe&"
import script from "./OrderPackageItems.vue?vue&type=script&lang=js&"
export * from "./OrderPackageItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\11\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e55ec3fe')) {
      api.createRecord('e55ec3fe', component.options)
    } else {
      api.reload('e55ec3fe', component.options)
    }
    module.hot.accept("./OrderPackageItems.vue?vue&type=template&id=e55ec3fe&", function () {
      api.rerender('e55ec3fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business-orders/OrderPackageItems.vue"
export default component.exports